"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var component_1 = require("../../component");
var attr_1 = require("../../component/trait/attr");
var lang_1 = require("../../../core/lang");
var vdom_1 = require("../../vdom");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.path = '';
        _this.target = '';
        _this.href = 'javascript:';
        _this.match = false;
        _this.onClick = function () {
            core_1.st.route = {
                path: _this.path,
                params: _this.params
            };
        };
        _this.onConnect = function () {
            _this.match = _this.isMatch();
            // register callback for future route changes
            core_1.st.router.addOnAfterMatchHandler(_this.onAfterMatchHandler);
        };
        _this.onAfterMatchHandler = function () { return __awaiter(_this, void 0, void 0, function () {
            var matchBefore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        matchBefore = this.match;
                        this.match = this.isMatch();
                        if (!(matchBefore != this.match)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.rerender()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.updateActiveClass = function () {
            if (!Array.isArray(_this.class)) {
                _this.class = [_this.class];
            }
            var activeClassNames = _this.activeClass || core_1.st.router.activeLinkClass;
            if (!Array.isArray(activeClassNames)) {
                activeClassNames = [activeClassNames];
            }
            var filteredClasses = _this.class.filter(function (className) { return activeClassNames.indexOf(className) === -1; });
            if (_this.match) {
                filteredClasses = lang_1.mergeArrays(filteredClasses, activeClassNames);
            }
            _this.class = filteredClasses;
        };
        _this.isMatch = function () {
            if (core_1.st.route) {
                var matcher = core_1.st.router.match[_this.path];
                if (matcher && lang_1.equalObjects(matcher.params, _this.params || {})) {
                    if (matcher.isExact || matcher.isPartial) {
                        return true;
                    }
                }
            }
            return false;
        };
        _this.render = function () {
            _this.updateActiveClass();
            return vdom_1.tsx("fragment", null,
                _this.renderChildren(),
                _this.match
                    ? _this.renderSlot(Link_1.ACTIVE_LINK_SLOT)
                    : _this.renderSlot(Link_1.INACTIVE_LINK_SLOT));
        };
        _this.onDisconnect = function () {
            core_1.st.router.removeOnAfterMatchHandler(_this.onAfterMatchHandler);
        };
        return _this;
    }
    Link_1 = Link;
    var Link_1;
    Link.ACTIVE_LINK_SLOT = 'ACTIVE_LINK_SLOT';
    Link.INACTIVE_LINK_SLOT = 'INACTIVE_LINK_SLOT';
    __decorate([
        component_1.attr,
        __metadata("design:type", String)
    ], Link.prototype, "path", void 0);
    __decorate([
        component_1.attr,
        __metadata("design:type", Object)
    ], Link.prototype, "params", void 0);
    __decorate([
        component_1.attr(attr_1.AttrType.DOM_TRANSPARENT),
        __metadata("design:type", String)
    ], Link.prototype, "target", void 0);
    __decorate([
        component_1.attr(attr_1.AttrType.DOM_TRANSPARENT),
        __metadata("design:type", String)
    ], Link.prototype, "href", void 0);
    __decorate([
        component_1.attr,
        __metadata("design:type", String)
    ], Link.prototype, "activeClass", void 0);
    Link = Link_1 = __decorate([
        component_1.component({ tag: 'a' })
    ], Link);
    return Link;
}(core_1.st.component));
exports.Link = Link;
//# sourceMappingURL=link.js.map